// v222 — Build-Info landing page (item 33 Phase A of
// docs/PRODUCT-ROADMAP.md).
//
// The sidebar nav link "Build-Info" lands here; we list every project
// the caller can read with a "Browse builds" jump to the per-project
// browse page. A future Phase B can fold an org-wide recent-builds
// feed in alongside; for Phase A the project picker is enough.

import { Link } from 'react-router-dom';
import { Activity, ChevronRight } from 'lucide-react';
import { useProjects } from '../api/client';
import { Card, CardBody, CardHeader } from '../components/ui/Card';

export function Builds() {
  const { data: projects, error, isLoading } = useProjects();

  return (
    <div className="space-y-6">
      <div>
        <p className="orb-eyebrow text-accent/80 mb-2">Provenance</p>
        <h1 className="text-2xl font-display font-semibold text-fg leading-tight">
          Build-Info
        </h1>
        <p className="text-fg-muted text-sm mt-2 max-w-3xl">
          Each project that has CI publishing build provenance through the
          standard <code className="font-mono">/api/build</code> surface keeps
          a per-build record here — name, number, source commit, CI agent, and
          which artifacts shipped from it. Pick a project to browse its build
          history.
        </p>
      </div>

      <Card>
        <CardHeader
          title="Projects"
          description="Visible projects you can browse builds for."
        />
        {isLoading && (
          <CardBody>
            <p className="text-fg-muted text-sm">Loading…</p>
          </CardBody>
        )}
        {error && (
          <CardBody>
            <p className="text-danger font-mono text-sm">{String(error)}</p>
          </CardBody>
        )}
        {projects?.length === 0 && (
          <CardBody>
            <p className="text-fg-muted text-sm">
              No projects visible. Ask a project admin to add you, or create
              one from <Link to="/projects" className="text-accent">Projects</Link>.
            </p>
          </CardBody>
        )}
        {projects && projects.length > 0 && (
          <div className="divide-y divide-border">
            {projects.map((p) => (
              <Link
                key={p.id}
                to={`/projects/${p.id}/builds`}
                className="flex items-center justify-between px-5 py-3 hover:bg-bg-hover transition-colors"
              >
                <div className="flex items-center gap-3 min-w-0">
                  <Activity className="h-4 w-4 text-fg-subtle shrink-0" />
                  <div className="min-w-0">
                    <div className="font-medium text-fg truncate">{p.name}</div>
                    <code className="text-xs text-fg-muted">{p.slug}</code>
                  </div>
                </div>
                <ChevronRight className="h-4 w-4 text-fg-subtle" />
              </Link>
            ))}
          </div>
        )}
      </Card>
    </div>
  );
}
